import { createContext } from "react";

export type Theme = "dark" | "light" | "system";

export interface RelayMetadata {
  /** List of relays with read/write permissions */
  relays: { url: string; read: boolean; write: boolean }[];
  /** Unix timestamp of when the relay list was last updated */
  updatedAt: number;
}

export interface AppConfig {
  /** Current theme */
  theme: Theme;
  /** NIP-65 relay list metadata */
  relayMetadata: RelayMetadata;
  /** Whether to use the community relay (goskatespots.nostr1.com) for skate content.
   * When true (default), community relay is always included for reads/writes.
   * When false, only user's configured relays are used.
   * Note: Logged-out users always use community relay regardless of this setting.
   */
  useSkateRelay: boolean;
  /** Whether to use a local on-device Citrine relay (Android only) for skate
   * content. When true AND a Citrine relay is reachable, it is prepended to
   * reads (instant local hits) and included in writes (local backup + offline
   * capture). Opt-in and no-op on non-Android / when Citrine isn't running.
   * Defaults to false. */
  useCitrineRelay?: boolean;
}

export interface AppContextType {
  /** Current application configuration */
  config: AppConfig;
  /** Update configuration using a callback that receives current config and returns new config */
  updateConfig: (updater: (currentConfig: Partial<AppConfig>) => Partial<AppConfig>) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);
